export default "__VITE_ASSET__ff6e5bd8__"